import styled, { css } from 'styled-components';

export const Root = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${({ theme: { colors = {} } }) =>
    `color-mix(in oklch, ${colors.onSurface ?? '#E4E1ED'} 4%, transparent)`};
  border: 0;
  border-radius: 9px;
  padding: 2px;
  gap: 0;
`;

interface SegmentProps {
  $isActive?: boolean;
}

export const Segment = styled.button<SegmentProps>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 0;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 7px;
  cursor: pointer;
  white-space: nowrap;
  transition: background ${({ theme: { motion } }) => motion?.duration?.fast ?? '120ms'},
    color ${({ theme: { motion } }) => motion?.duration?.fast ?? '120ms'};

  ${({ theme: { colors = {} } }) => css`
    color: ${colors.onSurfaceVariant ?? '#C7C4D7'};
    &:hover {
      color: ${colors.onSurface ?? '#E4E1ED'};
    }
  `}

  ${({ $isActive, theme: { colors = {}, elevation } }) =>
    $isActive &&
    css`
      background: ${colors.surfaceContainerHighest ?? '#34343D'};
      color: ${colors.onSurface ?? '#E4E1ED'};
      box-shadow: ${elevation?.level1 ?? '0 1px 2px rgba(0, 0, 0, 0.18)'};
    `}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
    outline-offset: 2px;
  }
`;

